// customHooks.js
import { useState, useEffect } from "react";
import * as api from "../../api/index";
import { handleApiError } from "Helper";

export const useFetchCurrency = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchCurrency = async () => {
            try {
                const { data } = await api.getActiveCurrency();
                data.data.map((item) => {
                    item.representation =
                        item.currencyCode + "  -  " + item.name + "  -  " + item.symbol;
                    return item;
                });
                setData(data.data);
            } catch (error) {
                handleApiError(error);
            }
        };

        fetchCurrency();
    }, []);

    return data;
};

